import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteReferralMutation as useChDeleteReferralMutationType } from "@/modules/patients/detail/referral/ch/services/__generated__/useChDeleteReferralMutation.graphql"

const deleteReferralMutation = graphql`
  mutation useChDeleteReferralMutation($input: Ch_deleteReferralLetterInput!) {
    ch_deleteReferralLetter(input: $input) {
      ch_ReferralLetter {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteReferralMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteReferralMutationType>(deleteReferralMutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteReferralMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteReferralMutation }
